import { put, call } from 'lib/redux';
import * as types from 'constants/ActionTypes';
import getReportDetailsService from 'services/getReportDetails.service';
import history from 'store/CreateHistory';
import { decodeAndDecrypt, convertFileToBase64 } from 'utils/app.utils';
import {
  KEY, INITIALIZATION_VECTOR, FILE_TYPES, FILE_FORMATS,
} from 'constants/AppConstants';
import uploadResourceFileService from 'services/uploadResourceFile.service';
import i18n from 'i18n';
import { fetchOrderClosureReasonsSaga } from 'features/cancel-order-dialog/CancelOrder.saga';
import ErrorCodes from 'constants/ErrorCodes';
import { isAuthorized } from 'utils/auth.utils';

export function* loadUploadInformationSaga() {
  try {
    if (isAuthorized()) yield call(fetchOrderClosureReasonsSaga);
    yield put({ type: types.LOADING_UPLOAD_INFORMATION_PAGE });
    const { location: { search } } = history;
    const query = new URLSearchParams(search);
    const encryptedReportId = query.get('id');
    const signature = query.get('signature'); // #genai
    const reportId = yield call(decodeAndDecrypt, encryptedReportId, KEY, INITIALIZATION_VECTOR);

    const reportDetailsResponse = yield call(getReportDetailsService, reportId, signature);
    if (!reportDetailsResponse.ok) {
      const error = new Error(reportDetailsResponse.json.errorDescription);
      error.errorCode = reportDetailsResponse.json.errorCode;
      throw error;
    }
    yield put({ type: types.LOAD_UPLOAD_INFORMATION_PAGE_SUCCESS, reportId, reportDetails: reportDetailsResponse.json });
  } catch (err) {
    yield put({ type: types.LOAD_UPLOAD_INFORMATION_PAGE_ERROR, error: err });
  }
}
export function* uploadBlueprintFileSaga({ file }) {
  try {
    const { t } = i18n;
    const fileName = file.name;

    if (file.type.match('application/pdf')) {
      yield put({ type: types.UPLOAD_INFORMATION_UPLOADING_BLUEPRINT_FILE });
      const requestBody = {
        fileType: FILE_TYPES.SubmittedBlueprint,
        fileFormat: FILE_FORMATS.PDF,
        validateFile: true,
        fileName,
        fileData: file,
      };
      const response = yield call(uploadResourceFileService, requestBody);

      if (!response.ok) {
        const error = new Error(response.json.errorDescription);
        error.errorCode = response.json.errorCode;
        throw error;
      }
      const { json: { fileId } } = response;
      const fileData = yield convertFileToBase64(file);

      yield put({
        type: types.UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_FILE_SUCCESS, fileData, fileName, fileId,
      });
    } else {
      yield put({ type: types.UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_FILE_ERROR, error: t('blueprint_order__unsupported_file_format') });
    }
  } catch (error) {
    yield put({
      type: types.UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_FILE_ERROR,
      error: error.errorCode === ErrorCodes.FileSizeExceeded ? error?.message : 'Internal Server Error',
    });
  }
}
